import Swiper, { Navigation, Pagination, Autoplay, Lazy } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, Lazy]);


    var swiperCustomes = new Swiper(".section-topbar .swiper", {
        slidesPerView: 1,
        autoplay: true,
        loop: true,
        navigation: {
          nextEl: '.info.swiper-button-next',
          prevEl: '.info.swiper-button-prev',
      }
       
      });
      var btnCopy =  document.querySelector('#btnCopy')
      var btnSpaceSopy = document.querySelector('.copy')
      
      if(btnSpaceSopy){
        btnSpaceSopy.addEventListener('click', function(){
          btnCopy.click()
        })
        btnCopy.addEventListener('click', function(){
          var copyText = document.querySelector(".copy");
          var textNode = copyText.childNodes[0];
        
        
          var range = document.createRange();
          range.selectNode(textNode);
        
        
          window.getSelection().removeAllRanges();
          window.getSelection().addRange(range);
        
          document.execCommand('copy');
          btnCopy.innerHTML = 'copiado'
  
          setTimeout(function(){
            btnCopy.innerHTML =  `
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5417 12.9915C1.76056 13.2103 2.05724 13.3332 2.36666 13.3332H8.83366C9.14309 13.3332 9.43977 13.2103 9.65863 12.9915L9.69178 12.9584C9.91053 12.7395 10.0335 12.4428 10.0335 12.1334V5.66652C10.0335 5.3571 9.91053 5.06043 9.69178 4.84157L9.65863 4.80841C9.43977 4.58967 9.14309 4.46674 8.83366 4.46674H2.36666C2.05724 4.46674 1.76056 4.58967 1.5417 4.80841L1.50855 4.84157C1.2898 5.06042 1.16687 5.3571 1.16687 5.66652V12.1334C1.16687 12.4428 1.2898 12.7395 1.50855 12.9584L1.5417 12.9915ZM10.5164 4.01696L10.4833 3.98369C10.0458 3.54621 9.45229 3.30034 8.83344 3.30034H2.36644C1.74756 3.30034 1.15412 3.5462 0.716629 3.98369L0.683362 4.01696C0.24587 4.45444 0 5.04802 0 5.66674V12.1336C0 12.7524 0.245862 13.3459 0.683362 13.7835L0.716629 13.8166C1.15412 14.2542 1.74759 14.5001 2.36644 14.5001H8.83344C9.45232 14.5001 10.0458 14.2542 10.4833 13.8166L10.5164 13.7835C10.954 13.3459 11.1999 12.7524 11.1999 12.1336V5.66674C11.1999 5.04799 10.954 4.45444 10.5164 4.01696Z" fill="#031D41"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2 10.5331H11.6335C11.9429 10.5331 12.2396 10.4102 12.4585 10.1914L12.4916 10.1583C12.7104 9.9394 12.8333 9.64272 12.8333 9.3333V2.8664C12.8333 2.55698 12.7104 2.26031 12.4916 2.04145L12.4585 2.0083C12.2396 1.78956 11.9429 1.66662 11.6335 1.66662H5.16649C4.85707 1.66662 4.56039 1.78955 4.34153 2.0083L4.30837 2.04145C4.08963 2.26031 3.96669 2.55698 3.96669 2.8664V3.29989H2.80005V2.8664C2.80005 2.24754 3.04591 1.6541 3.48341 1.21662L3.51668 1.18335C3.95417 0.745867 4.54764 0.5 5.16649 0.5H11.6335C12.2522 0.5 12.8458 0.745858 13.2834 1.18335L13.3165 1.21662C13.7541 1.6541 13.9999 2.24757 13.9999 2.8664V9.3333C13.9999 9.95217 13.7541 10.5456 13.3165 10.9831L13.2834 11.0162C12.8458 11.4538 12.2522 11.6997 11.6335 11.6997H11.2L11.2 10.5331Z" fill="#031D41"></path>
            </svg>
        `;
          }, 2000)
          // alert("Cupom copiado: " + textNode.textContent.trim());
        })
      }
   

              // Depois de 5 segundos, restaura o texto original do botão
